import { breakpoint } from '../../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { fontFamilyBold, text } from '../../../styling/mixins/typography';
import Dropdown from '../../Dropdown';

export const StyledFormWrapper = styled.div`
  grid-column: span 2;

  .title {
    margin-bottom: 0.8rem;
  }

  .description {
    ${text('large')}
    max-width: 768px;
    margin-bottom: 1.6rem;

    ${breakpoint('large')} {
      margin-bottom: 2.4rem;
    }
  }

  .form {
    display: flex;
    flex-direction: column;

    &--settings:not(:last-child) {
      margin-bottom: 3.2rem;
    }

    &__title {
      text-transform: uppercase;
      margin-bottom: 1.6rem;
    }
  }

  .input__wrapper {
    margin-bottom: 1.6rem;
  }

  .label {
    ${text('large')}
    ${fontFamilyBold}
    margin-bottom: 0.8rem;
  }

  .input {
    ${text('large')}
  }

  .radio__wrapper {
    display: flex;
    flex-direction: column;
    padding-top: 0.8rem;
    padding-bottom: 2.4rem;

    ${breakpoint('large')} {
      padding-top: 1.6rem;
      padding-bottom: 3.2rem;
    }
  }

  .radio {
    ${text('large')}
    display: flex;
    gap: 0.8rem;

    &:not(:last-child) {
      margin-bottom: 1.6rem;
    }
  }

  .btn__wrapper {
    display: flex;
    gap: 0.8rem;
  }

  .btn--settings {
    margin-top: 0.8rem;
    width: 100%;
    ${fontFamilyBold}
    text-transform: uppercase;

    ${breakpoint('large')} {
      margin-top: 1.6rem;
    }
  }
`;

export const StyledFormDropdown = styled(Dropdown)`
  .dropdown-select {
    padding: 1.2rem;
  }
`;
